module.exports = "pegasus_template/assets/blocks/column-8-theme3.png";